import { Grid2 as Grid, Typography } from "@mui/material"
import { getAllSpecializationAreasReq } from "../../../../../redux/guest-slices/common.slice"
import InputField1 from "../../../../../components/ui/InputField1"
import { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import SpecializationAreas from "../../../../../components/ui/SpecializationAreas"

function SpiritualAdvisor({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b41"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="trainingBackground"
          label="Training in Spiritual Advisor techniques *"
          placeholder="Enter Training in Spiritual Advisor techniques"
          defaultValue={specialist?.profile?.trainingBackground || ""}
          errText="Please enter training in spiritual advisor techniques"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          name="spiritualPractices"
          label="Spiritual Practices *"
          errText="Please enter spiritual practices"
          defaultValue={specialist?.profile?.spiritualPractices || ""}
          placeholder="Describe the spiritual practices you offer, such as meditation, prayer, energy healing, etc"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          label="Specialization Areas *"
          name="specializationAreaDescription"
          errText="Please enter specialization areas"
          defaultValue={specialist?.profile?.specializationAreaDescription || ""}
          placeholder="List your areas of specialization, such as grief and loss, life purpose, mindfulness, etc."
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Specialization Areas *"
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Provide spiritual guidance to help clients find meaning and purpose. Share your spiritual practices and areas of expertise
      </Typography>
    </Fragment>
  )
}

export default SpiritualAdvisor